export default "__VITE_ASSET__4$$4NFGd__"